import { exportPatternsZip, type Pattern } from "@midi-fantom-utils/midi-util";

export type ExportBarProps = {
  patterns: ReadonlyArray<Pattern>;
  projectName: string;
  onError?: (msg: string) => void;
};

export const ExportBar = ({ patterns, projectName, onError }: ExportBarProps) => {
  const disabled = patterns.length === 0;
  const handleExport = () => {
    if (disabled) return;
    try {
      const bytes = exportPatternsZip({ projectName, patterns });
      const blob = new Blob([bytes as unknown as BlobPart], { type: "application/zip" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${projectName}_patterns.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      if (onError) onError(`Не удалось экспортировать: ${(err as Error).message ?? err}`);
    }
  };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <button
        type="button"
        className="btn btn--primary"
        onClick={handleExport}
        disabled={disabled}
      >
        ⬇ Скачать ZIP-бандл ({patterns.length} паттернов)
      </button>
      {disabled ? <span className="muted">Нет паттернов для экспорта</span> : null}
    </div>
  );
};
